/**
 * Phonics Letter Jj — 课程数据配置
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/jj/）
 *
 * 页面结构：
 * P3: Learn the words（无视频，左右分栏：单词 | 词组）
 * P4: 4格词汇（jellyfish/jet/jeep/jam.mp4）
 * P5: Repeat 4 words（Jj.mp4）
 * P9: Story 1 (j1.mp4)
 * P10: Story 2 (j2.mp4)
 * P11: Story 3 (j3.mp4)
 * P12: Learn the sentences (4) — text-repeat-table
 * P13: Learn the sentences (5) — text-repeat-table
 * P14: Chant (Jj.mp4)
 */

const MEDIA_BASE = '/media/phonics/jj';
const V = 'v1';

export const letterData = {
  letter: 'Jj',
  title: 'Phonics Letter Jj',
  subtitle: 'Jj — Jellyfish',

  mediaBase: MEDIA_BASE,

  // P3/P5/P14: Song/Chant 视频（完整时长）
  songVideo: {
    src: `${MEDIA_BASE}/Jj.mp4?${V}`,
    poster: `${MEDIA_BASE}/Jj.png?${V}`,
    startTime: 0,
    endTime: null,
  },

  // P5: 4格词汇视频（Repeat 4 words 复用）
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/jellyfish.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/jet.mp4?${V}`,       cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/jeep.mp4?${V}`,      cover: `${MEDIA_BASE}/image10.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/jam.mp4?${V}`,        cover: `${MEDIA_BASE}/image11.png?${V}` },
  ],

  storySections: [

    // ============================================================
    // Section 1: P3 Learn the words — 无视频，左右分栏（单词 vs 词组）
    // ============================================================
    {
      label: 'Learn the words',
      layout: 'text-left-words-right-phrases',
      splitAt: 4,
      lines: [
        // 左侧单词
        { en: 'in',     cn: '进入',   audioEn: `${MEDIA_BASE}/w_en_in.mp3?${V}`,     audioCn: `${MEDIA_BASE}/w_cn_in.mp3?${V}` },
        { en: 'fly',    cn: '飞',     audioEn: `${MEDIA_BASE}/w_en_fly.mp3?${V}`,     audioCn: `${MEDIA_BASE}/w_cn_fly.mp3?${V}` },
        { en: 'drive',  cn: '驾驶',   audioEn: `${MEDIA_BASE}/w_en_drive.mp3?${V}`,   audioCn: `${MEDIA_BASE}/w_cn_drive.mp3?${V}` },
        { en: 'happy',  cn: '开心',   audioEn: `${MEDIA_BASE}/w_en_happy.mp3?${V}`,   audioCn: `${MEDIA_BASE}/w_cn_happy.mp3?${V}` },
        // 右侧词组
        { en: 'jump in',           cn: '跳进',    audioEn: `${MEDIA_BASE}/s_en_jump_in_跳进.mp3?${V}`,     audioCn: `${MEDIA_BASE}/s_cn_jump_in_跳进.mp3?${V}` },
        { en: 'flies jet',         cn: '开飞机',  audioEn: `${MEDIA_BASE}/s_en_flies_jet_开飞机.mp3?${V}`,   audioCn: `${MEDIA_BASE}/s_cn_flies_jet_开飞机.mp3?${V}` },
        { en: 'drives jeep',       cn: '开吉普车', audioEn: `${MEDIA_BASE}/s_en_drives_jeep_开吉普车.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_drives_jeep_开吉普车.mp3?${V}` },
        { en: 'Jellyfish is happy', cn: '海蜇开心', audioEn: `${MEDIA_BASE}/s_en_jellyfish_is_happy_海蜇开心.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_jellyfish_is_happy_海蜇开心.mp3?${V}` },
      ],
    },

    // ============================================================
    // Section 2: P9 Story 1
    // ============================================================
    {
      label: 'Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/j1.mp4?${V}`, poster: `${MEDIA_BASE}/image13.png?${V}` }],
      lines: [
        { en: 'Jellyfish likes the jet.',    cn: '海蜇喜欢飞机。',   audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'Jellyfish jumps in.',         cn: '海蜇跳进去。',     audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
        { en: 'Jellyfish flies the jet.',    cn: '海蜇驾驶飞机。',   audioEn: `${MEDIA_BASE}/story1_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3?${V}` },
      ],
    },

    // ============================================================
    // Section 3: P10 Story 2
    // ============================================================
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/j2.mp4?${V}`, poster: `${MEDIA_BASE}/image14.png?${V}` }],
      lines: [
        { en: 'Jellyfish likes the jeep.',   cn: '海蜇喜欢吉普车。', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: 'Jellyfish jumps in.',         cn: '海蜇跳进去。',     audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
        { en: 'Jellyfish drives the jeep.',  cn: '海蜇驾驶吉普车。', audioEn: `${MEDIA_BASE}/story2_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3?${V}` },
      ],
    },

    // ============================================================
    // Section 4: P11 Story 3
    // ============================================================
    {
      label: 'Learn the Story (3)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/j3.mp4?${V}`, poster: `${MEDIA_BASE}/image15.png?${V}` }],
      lines: [
        { en: 'Jellyfish likes the jam.',   cn: '海蜇喜欢果酱。',  audioEn: `${MEDIA_BASE}/story3_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_1.mp3?${V}` },
        { en: 'Jellyfish eats the jam.',    cn: '海蜇吃果酱。',    audioEn: `${MEDIA_BASE}/story3_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_2.mp3?${V}` },
        { en: 'Jellyfish is happy.',        cn: '海蜇很开心。',     audioEn: `${MEDIA_BASE}/story3_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_3.mp3?${V}` },
      ],
    },

    // ============================================================
    // Section 5: P7 — like likes, jump jumps
    // ============================================================
    {
      label: 'Learn the sentences (4)',
      layout: 'text-repeat-table',
      headerTitle: 'like likes, jump jumps',
      groups: [
        {
          title: 'like → likes',
          rows: [
            { en: 'Jellyfish likes the jet.',                          audioEn: `${MEDIA_BASE}/s_en_p12_1.mp3?${V}` },
            { en: 'I like. You like. They like.',         cn: '我、你、他们',   audioEn: `${MEDIA_BASE}/s_en_p12_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_p12_2.mp3?${V}` },
            { en: 'He likes. She likes. It likes.',      cn: '男的他，女的她，动物它', audioEn: `${MEDIA_BASE}/s_en_p12_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_p12_3.mp3?${V}` },
          ],
        },
        {
          title: 'jump → jumps',
          rows: [
            { en: 'Jellyfish jumps in.',                           audioEn: `${MEDIA_BASE}/s_en_p12_4.mp3?${V}` },
            { en: 'I jump. You jump. They jump.',                  audioEn: `${MEDIA_BASE}/s_en_p12_5.mp3?${V}` },
            { en: 'He jumps. She jumps. It jumps.',                 audioEn: `${MEDIA_BASE}/s_en_p12_6.mp3?${V}` },
          ],
        },
      ],
    },

    // ============================================================
    // Section 6: P8 — drive drives, eat eats
    // ============================================================
    {
      label: 'Learn the sentences (5)',
      layout: 'text-repeat-table',
      headerTitle: 'drive drives, eat eats',
      groups: [
        {
          title: 'drive → drives',
          rows: [
            { en: 'Jellyfish drives the jeep.',                     audioEn: `${MEDIA_BASE}/s_en_p12_7.mp3?${V}` },
            { en: 'I drive. You drive. They drive.',                audioEn: `${MEDIA_BASE}/s_en_p12_8.mp3?${V}` },
            { en: 'He drives. She drives. It drives.',              audioEn: `${MEDIA_BASE}/s_en_p12_9.mp3?${V}` },
          ],
        },
        {
          title: 'eat → eats',
          rows: [
            { en: 'Jellyfish eats jam.',                            audioEn: `${MEDIA_BASE}/s_en_p13_1.mp3?${V}` },
            { en: 'I eat. You eat. They eat.',                     audioEn: `${MEDIA_BASE}/s_en_p13_2.mp3?${V}` },
            { en: 'He eats. She eats. It eats.',                   audioEn: `${MEDIA_BASE}/s_en_p13_3.mp3?${V}` },
          ],
        },
      ],
    },

    // ============================================================
    // Section 7: P9 — fly flies, is am are
    // ============================================================
    {
      label: 'Learn the sentences (6)',
      layout: 'text-repeat-table',
      headerTitle: 'fly flies, is am are',
      groups: [
        {
          title: 'fly → flies',
          rows: [
            { en: 'Jellyfish flies the jet.',                      audioEn: `${MEDIA_BASE}/s_en_p13_4.mp3?${V}` },
            { en: 'I fly. You fly. They fly.',                     audioEn: `${MEDIA_BASE}/s_en_p13_5.mp3?${V}` },
            { en: 'He flies. She flies. It flies.',                audioEn: `${MEDIA_BASE}/s_en_p13_6.mp3?${V}` },
          ],
        },
        {
          title: 'is/am/are',
          rows: [
            { en: 'Jellyfish is happy.',                           audioEn: `${MEDIA_BASE}/s_en_p13_7.mp3?${V}` },
            { en: 'I am happy. You are happy. They are happy.',    audioEn: `${MEDIA_BASE}/s_en_p13_8.mp3?${V}` },
            { en: 'He is happy. She is happy. It is happy.',       audioEn: `${MEDIA_BASE}/s_en_p13_9.mp3?${V}` },
          ],
        },
      ],
    },

  ],

  coverBg:     `${MEDIA_BASE}/image7.png?${V}`,
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
